module.exports = __webpack_public_path__ + "3660c9ee7939d02f62c4769ff48282d0.pdf";